import { actions } from './services';
import { setCookie } from '@/helpers/userHelper';

const getInitialState = () => {
  return {
    cart: {
      items: [],
      displayCart: false,
      checkout_url: '',
      cart_url: '',
      items_count: 0,
      discount: 0,
      discount_names: '',
      shipping_cost: 0.0,
      taxes: 0.0,
      grand_total: 0.0,
      subtotal: 0.0,
      isLoading: false,
      needsRefresh: false,
      hasVetShopItems: 0
    },
    leaveCartPopup: {
      display: false,
      callback: null
    },
    clientId: null,
    petToSelectClientFor: { id: 0, name: '' }
  };
};

//by default => initial state
const state = getInitialState();

const mutations = {
  removeFromCart: (state, itemId) => {
    state.cart = {
      ...state.cart,
      items: state.cart.items.filter(element => element.item_id !== itemId)
    };
    state.cart.isLoading = false;
  },
  putCartContent: (state, payload) => {
    state.cart = {
      ...state.cart,
      ...payload,
      isLoading: false
    };

    var cartStatus = state.cart.items.reduce(
      (accumulator, value) => {
        if (value.isPet == true) {
          accumulator.hasPet = true;
          accumulator.clientId = value.clientId;
          if (value.clientId == 0) {
            accumulator.petToSelectClientFor = {
              id: value.petId,
              name: value.petName
            };
          }
        }
        return accumulator;
      },
      { hasPet: false, clientId: 0, petToSelectClientFor: { id: 0, name: '' } }
    );
    if (state.cart.hasVetShopItems == 1) {
      state.clientId = -1;
      setCookie('client_id', -1);
    } else if (cartStatus.hasPet == true && cartStatus.clientId != 0) {
      state.clientId = cartStatus.clientId;
      setCookie('client_id', cartStatus.clientId);
    }
    state.petToSelectClientFor = cartStatus.petToSelectClientFor;
  },
  displayCart: state => {
    state.cart = {
      ...state.cart,
      displayCart: !!!state.cart.displayCart
    };
  },
  startLoading: state => {
    state.cart = {
      ...state.cart,
      isLoading: true
    };
  },
  openLeaveCartPopup: (state, callback) => {
    state.leaveCartPopup.display = true;
    state.leaveCartPopup.callback = callback;
  },
  closeLeaveCartPopup: state => {
    state.leaveCartPopup.display = false;
  },

  updateItem: (state, updatedItem) => {
    state.cart = {
      ...state.cart,
      items: state.cart.items.map(item => {
        if (updatedItem.item_id === item.item_id) {
          updatedItem.totalItemPrice = item.price * item.qty;
          return updatedItem;
        }
        return item;
      })
    };
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
